import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import s from './CommentPanel.module.scss';

const LINES = 3;

// Long selections are cut to a few lines.
const Excerpt = ({ isExpanded, onToggle, children }) => {
    const [text, setText] = useState(null);
    const [size, setSize] = useState({ height: 0, overflows: false });

    useEffect(() => {
        if (!text) return;
        const measure = () => {
            const lineHeight = parseFloat(getComputedStyle(text).lineHeight);
            setSize({
                height: text.scrollHeight,
                overflows: text.scrollHeight > lineHeight * LINES + 1,
            });
        };
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(text);
        return () => observer.disconnect();
    }, [text, children]);

    return (
        <span
            ref={setText}
            className={classNames(s.Excerpt, {
                [s['Excerpt--Faded']]: size.overflows && !isExpanded,
            })}
            style={isExpanded ? { maxHeight: size.height } : undefined}
            onClick={onToggle}>
            {children}
        </span>
    );
};

export default Excerpt;
